<template>
  <div
    :class="[
      $style.notificationItemDropdown,
      { [$style.notificationInPopup]: !isNotificationPage },
    ]"
    :data-readed="notification.readed"
  >
    <ItemWrapper
      :notification="notification"
      :is-notification-expanded="isNotificationExpanded"
      :is-notification-page="isNotificationPage"
      :class="$style.notificationItemBlock"
      @click.prevent="toggleNotification"
    >
      <template #icon>
        <img v-if="notification.data.icon" :src="notification.data.icon.url" />
      </template>
      <template v-if="isNotificationPage" #rightSide>
        <p
          v-if="platform.isDesktop || platform.isTablet"
          :class="[
            $style.overflowNotificationExpanded,
            {
              [$style.hidenTextExpanded]: isNotificationExpanded,
              [$style.hidenPersonalNotification]: notification.type === 'notification',
            },
          ]"
        >
          {{
            notification.data.messageText && notification.type !== ENotificationSettingsType.Welcome
              ? snippet.format(notification.data.messageText)
              : ''
          }}
        </p>
        <BitNavExpandButton :is-expanded="isNotificationExpanded" />
      </template>
    </ItemWrapper>

    <div
      v-if="isNotificationPage && isNotificationExpanded"
      :class="[
        $style.notificationsContent,
        { [$style.activeNotification]: isNotificationExpanded },
      ]"
    >
      <component
        :is="modalName"
        v-if="isNotificationExpanded"
        :notification-params="notification.action.params"
        :is-notification-page="isNotificationPage"
        :is-notification-readed="notification.readed"
        :notification-id="notification.id"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { BitNavExpandButton } from '@bit/ui-kit';
import { useStoreModals } from '~/stores/abstract/modals';
import { useStoreMenuStatuses } from '~/stores/client/menuStatuses';
import { ELinkType } from '~/types/links';
import { ENotificationSettingsType, type INotificationFeedElement } from '~/types/notifications';
import ItemWrapper from '../itemWrapper/itemWrapper.vue';

const props = defineProps({
  notification: {
    type: Object as PropType<INotificationFeedElement>,
    required: true,
  },
  isNotificationPage: {
    type: Boolean,
    default: false,
  },
});

const snippet = useSnippet();
const storeModals = useStoreModals();
const storeMenuStatuses = useStoreMenuStatuses();
const platform = usePlatform();

const expandedNotifications = ref<string[]>([]);

const isNotificationExpanded = computed(() =>
  expandedNotifications.value.includes(props.notification.id)
);

const modalName = computed(() => {
  const fileName = camelize(props.notification.action!.modal);

  return defineAsyncComponent(() => import(`@/components/modal/${fileName}.vue`));
});

/**
 * Method that opens notification modal if player clicked at header
 * or open notification content if player is at notification page
 */
const toggleNotification = () => {
  if (props.isNotificationPage) {
    if (isNotificationExpanded.value) {
      expandedNotifications.value = expandedNotifications.value.filter(
        (notif) => notif !== props.notification.id
      );
    } else {
      expandedNotifications.value.push(props.notification.id);
    }
  } else {
    switch (props.notification?.action?.type) {
      case ELinkType.modal: {
        storeModals.openModal(props.notification.action.modal, {
          ...props.notification.action?.params,
          notificationId: props.notification.id,
        });
        break;
      }
      default:
        console.warn('Unknown notification action');
    }

    storeMenuStatuses.toggleNotificationsMenu(false);
  }
};
</script>

<style lang="scss" module src="./itemDropdown.scss"></style>
